/**
 * Перенаправление по ?autlet-tg=<ID> и #tvtourId=<tourId>
 */
(() => {
	var
		qs = new URLSearchParams(location.search),
		tgId = qs.get('autlet-tg');

	//Берём tvtourId из хэша
	var
		hashParams = new URLSearchParams(location.hash.slice(1)),
		tvtourId = hashParams.get('tvtourid');

	var tourId = qs.get('tourId') || tvtourId || '';

	if (tourId && typeof tourId == 'string') {
		var tourIdObj = JSON.parse(tourId);

		if (!tgId && typeof tourIdObj.autletTg != 'undefined')
			tgId = tourIdObj.autletTg;

	}

	if (!tourId && !tgId) return;

	// UTM-метки из query
	var
		utmSource = qs.get('utm_source'),
		utmId = qs.get('utm_id');

	if (utmId && !/^\d+$/.test(utmId))
		utmId = '';

	// Сохраняем UTM в BX_REF_UTM
	if (utmSource == 'bot') {
		setCookie('BX_REF_UTM', JSON.stringify({
			source: utmSource,
			id: utmId
		}), false);
	}

	if (ACCESS['ABONEMENT'] < ABONEMENT_PAID) {
		setCookie('BX_REF', tourId, false);

		//устанавливаем куки ИД юзера кто пригласил
		if (tgId)
			setCookie('BX_invite', tgId, false, 3);

		// location.replace(
		// 	'/personal/register/?invite=' + encodeURIComponent(tgId)
		// );
	}
})();